<template>
  <div>
    <div class="modal-vue">
      <!-- overlay -->
      <div class="overlay" v-if="showCategoryItemModal" @click="showCategoryItemModal = false"></div>
      <!-- modal -->
      <div class="modal-own" v-if="showCategoryItemModal">
        <h5 style="display: inline-block">{{modalTitle}}</h5>
        <i class="fa fa-times float-right" style="font-size: 2rem; cursor: pointer" @click="cancelCustomModal" aria-hidden="true"></i>
        <form>
          <div class="form-group" v-if="!isToppingsModal">
            <label for="exampleInputEmail1">Title</label>
            <input type="text" class="form-control" id="exampleInputEmail1" v-model="title" placeholder="Enter title">
          </div>
          <div class="form-group" v-if="!isToppingsModal">
            <label for="exampleInputEmail1">Item Number</label>
            <span v-if="latestShortId"> (Last number {{ latestShortId }})</span>
            <input type="number" class="form-control" id="exampleInputEmail1" v-model="shortId" placeholder="Only number">
          </div>
          <div class="form-group" v-if="!isToppingsModal">
            <label for="exampleFormControlTextarea1" >Description</label>
            <textarea class="form-control" id="exampleFormControlTextarea1" v-model="description"></textarea>
          </div>
          <div class="form-group" v-if="(isSelectionModal || isItemModal) && !isToppingsModal">
            <label for="exampleInputEmail1">Base Price</label>
            <input type="number" class="form-control" id="exampleInputEmail1" v-model="basePrice" placeholder="Enter Price">
          </div>
          <div class="form-group" v-if="isItemModal && !isToppingsModal">
            <label for="minOrderQty">Minimum order quantity</label>
            <input type="number" class="form-control" id="minOrderQty" v-model="minOrderQty" placeholder="Minimum order quantity">
          </div>
          <div class="d-flex align-items-center" v-if="(isSelectionModal || isItemModal) && !isToppingsModal">
            <input type="checkbox" v-model="specialItem" style="width: 30px; height: 30px;"><span class="ml-2">Special Item</span>
          </div>

          <div class="row" v-if="(isSelectionModal || isItemModal) && !isToppingsModal">
            <div class="d-flex align-items-center col-md-4 pr-0 py-4">
              <input type="checkbox" v-model="isSetDiffPrice" @click="setDiffPrice" style="width: 30px; height: 30px;"><span class="ml-2">Different price</span>
            </div>
            <div class="col-md-4">
              <div v-if="isSetDiffPrice" class="form-group">
                <label>In price</label>
                <input type="number" class="form-control" v-model="inPrice" placeholder="In price">
              </div>
            </div>
            <div class="col-md-4">
              <div v-if="isSetDiffPrice" class="form-group">
                <label>Out price</label>
                <input type="number" class="form-control" v-model="outPrice" placeholder="Out price">
              </div>
            </div>
          </div>

          <div class="row" v-if="isCategoryModal && !isToppingsModal">
            <div class="col-md-6">
              <div class="form-group">
                <label for="exampleFormControlSelect1">Send Terminal</label>
                <select class="form-control" id="exampleFormControlSelect1" v-model="terminalSelected">
                  <option v-for="(item, index) in assignOption" :key="index" :value="item.identity"> {{item.name}} </option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="exampleFormControlSelect1">Send Status</label>
                <select class="form-control" id="exampleFormControlSelect1" v-model="sendStatusSelected">
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row" v-if="!isToppingsModal">
            <div :class="addCustomMealDeal ? 'col-md-3 pr-0' : 'col-md-4'">
              <div class="form-group">
                <label for="exampleFormControlSelect1">Print Option</label>
                <select class="form-control" id="exampleFormControlSelect1" @change="chooseItems()" v-model="printIdSelected">
                  <option v-for="(item, index) in printOptionDataList" :key="index" :value="item.id"> {{item.title}} </option>
                </select>
              </div>
            </div>
            <div :class="addCustomMealDeal ? 'col-md-3 px-1' : 'col-md-4'">
              <div class="form-group" v-if="isItemModal || isSelectionModal">
                <label for="exampleFormControlSelect1" >Assign to</label>
                <select class="form-control" id="exampleFormControlSelect1" v-model="assignSelected">
                  <option v-for="(item, index) in assignOption" :key="index" :value="item.identity"> {{item.name}} </option>
                </select>
              </div>
            </div>
            <div :class="addCustomMealDeal ? 'col-md-3 px-1' : 'col-md-4'">
              <div class="form-group" v-if="isItemModal || isSelectionModal">
                <label for="exampleFormControlSelect1">Status</label>
                <select class="form-control" id="exampleFormControlSelect1" v-model="statusSelected">
                  <option>Active</option>
                  <option>Inactive</option>
                </select>
              </div>
            </div>
            <div v-if="addCustomMealDeal" :class="addCustomMealDeal ? 'col-md-3 pl-1' : 'col-md-4'">
              <div class="form-group">
                <label for="exampleFormControlSelect11">Print Type</label>
                <select class="form-control" id="exampleFormControlSelect11" v-model="printTypeSelected">
                  <option value="Default">Default</option>
                  <option value="Grouped">Grouped</option>
                </select>
              </div>
            </div>
            <div v-if="isCategoryModal || isItemModal || isSelectionModal" class="col-md-12">
              <div v-if="this.$store.state.restaurantData && this.$store.state.restaurantData.vatDetails && this.$store.state.restaurantData.vatDetails.status == 'Active'" class="row pt-2" style="border: 1px solid #E3E3E3;">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="exampleFormControlSelect2">VAT</label>
                    <select class="form-control" id="exampleFormControlSelect2" v-model="vat.status" style="border-radius: 0;">
                      <option value="Active"> Active </option>
                      <option value="Inactive"> Inactive </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group mb-0 d-flex" style="align-items: center; margin-top: 2rem;">
                    <input type="checkbox" v-model="vatAppliedForIn" style="width: 30px; height: 30px;"><span class="ml-2"> In</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group mb-0 d-flex" style="align-items: center; margin-top: 2rem;">
                    <input type="checkbox" v-model="vatAppliedForOut" style="width: 30px; height: 30px;"><span class="ml-2"> Out</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="exampleFormControlSelect2">Default - %</label>
                    <div class="d-flex align-items-center">
                      <input type="text" v-model="defaultVatAmount" readonly class="form-control" id="exampleFormControlSelect2">
                      <span @click="vat.applicationType = 'Default'" style="padding: 8px 10px; border: 2px solid #E3E3E3; border-radius: 0; margin-left: 1px;">
                        <div :class="{'active': vat.applicationType === 'Default'}" class="customer-radio"></div>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="exampleFormControlSelect3">Custom - %</label>
                    <div class="d-flex align-items-center">
                      <input type="number" v-model="customVatAmount" class="form-control" id="exampleFormControlSelect3">
                      <span @click="vat.applicationType = 'Custom'" style="padding: 8px 10px; border: 2px solid #E3E3E3; border-radius: 0; margin-left: 1px;">
                        <div :class="{'active': vat.applicationType === 'Custom'}" class="customer-radio"></div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isCategoryModal || isItemModal || isSelectionModal" class="col-md-4">
              <div class="form-group">
                <label>Available day</label>
                <div class="btn-group availableDays">
                  <button type="button" @click="toggleDayList" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" style="color: #000; border-color: #E3E3E3;">
                    Days
                  </button>
                  <div class="dropdown-menu" :style="{visibility: isAvailableDayClicked == true ? 'visible' : 'hidden'}">
                    All <input type="checkbox" v-model="availableDays.all" @click="() => selectAvailableDay('All')">
                    <div class="dropdown-divider"></div>
                    Sun <input type="checkbox" v-model="availableDays.sun" @click="() => selectAvailableDay('Sun')"><br>
                    Mon <input type="checkbox" v-model="availableDays.mon" @click="() => selectAvailableDay('Mon')"><br>
                    Tue <input type="checkbox" v-model="availableDays.tue" @click="() => selectAvailableDay('Tue')"><br>
                    Wed <input type="checkbox" v-model="availableDays.wed" @click="() => selectAvailableDay('Wed')"><br>
                    Thu <input type="checkbox" v-model="availableDays.thu" @click="() => selectAvailableDay('Thu')"><br>
                    Fri <input type="checkbox" v-model="availableDays.fri" @click="() => selectAvailableDay('Fri')"><br>
                    Sat <input type="checkbox" v-model="availableDays.sat" @click="() => selectAvailableDay('Sat')"><br>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isCategoryModal" class="col-md-8">
              <div class="form-group">
                <label>Serving Times</label><br>
                <input type="checkbox" value="Morning" v-model="servingTimes"> Morning
                <input type="checkbox" value="Lunch" v-model="servingTimes" class="ml-3"> Lunch
                <input type="checkbox" value="Evening" v-model="servingTimes" class="ml-3"> Evening
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group" v-if="isItemModal || isSelectionModal">
                <label>Available at</label><br>
                <input type="checkbox" v-model="availableAt.delivery"> Delivery
                <input type="checkbox" v-model="availableAt.collection" class="ml-3"> Collection
              </div>
            </div>
          </div>

          <div class="row" v-if="isToppingsModal">
              <div class="col-md-12">
                  <div class="form-group">
                      <label for="exampleFormControlSelect1">Category</label>
                      <input type="text" class="form-control" v-model="toppingsCategory">
                  </div>
                  <div class="row">
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="exampleInputEmail1">Toppings Title</label>
                              <input type="text" class="form-control" id="exampleInputEmail1" v-model="toppingsTitle" aria-describedby="emailHelp" placeholder="Enter title">
                          </div>
                      </div>
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="exampleInputEmail1">Base Price</label>
                              <input type="number" class="form-control" id="exampleInputEmail1" v-model="toppingsBasePrice" aria-describedby="emailHelp" placeholder="Enter price">
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <button type="button" class="btn submitBtn" v-if="!isToppingsModal && !isCategoryModal && !isItemModal && !isSelectionModal">Submit</button>&nbsp;
          <button type="button" class="btn submitBtn" v-if="isCategoryModal || isItemModal || isSelectionModal" @click="createCategory">Submit</button>&nbsp;
          <button type="button" class="btn submitBtn" v-if="isToppingsModal" @click="createToppings">Submit</button>&nbsp;
          <button type="button" class="btn cancelBtn" @click="cancelCustomModal">Cancel</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import logout from './../../mixins/logoutMixins.js'

export default {
  props: ['modalTitle', 'isCategoryModal', 'isItemModal', 'isSelectionModal', 'isToppingsModal', 'categoryDataList', 'itemDataList', 'printOptionDataList', 'selectedItemPrintOptionId'],
  data () {
    return {
      showCategoryItemModal: false,
      title: '',
      description: '',
      basePrice: 0,
      minOrderQty: 0,
      toppingsCategory: '',
      toppingsTitle: '',
      toppingsBasePrice: '',
      toppingsEditId: '',
      isToppingsModalEditable: false,
      restaurantId: parseInt(localStorage.getItem('restaurantId')),
      categoryIdSelected: 0,
      itemIdSelected: 0,
      itemAccordingToCategory: [],
      editCategoryId: 0,
      editItemId: 0,
      assignOption: [
        {
          'identity': 'Kitchen',
          'name': 'Kitchen'
        },
        {
          'identity': 'Express',
          'name': 'Express'
        }
      ],
      assignSelected: '',
      terminalSelected: '',
      addFixedMealDeal: false,
      addCustomMealDeal: false,
      addGeneralMealDeal: false,
      printIdSelected: 0,
      statusSelected: '',
      sendStatusSelected: '',
      printTypeSelected: '',
      isSetDiffPrice: false,
      inPrice: '',
      inPriceG: '',
      outPrice: '',
      outPriceG: '',
      jwtToken: this.$cookies.get('token') || null,
      specialItem: false,
      shortId: null,
      latestShortId: null,
      customTopping: false,
      isAvailableDayClicked: false,
      availableDays: {
        all: null,
        sun: null,
        mon: null,
        tue: null,
        wed: null,
        thu: null,
        fri: null,
        sat: null
      },
      availableDaysArray: [],
      servingTimes: ['Morning', 'Lunch', 'Evening'],
      webToppingItems: '',
      availableAt: {
        delivery: true,
        collection: true
      },
      menuShowAt: '',
      menuShowAtOnline: '',
      customVatAmount: '',
      defaultVatAmount: '',
      vatAppliedForIn: true,
      vatAppliedForOut: true,
      vat: {
        status: '',
        applicationType: '',
        appliedFor: ''
      }
    }
  },
  mounted () {
    if (localStorage.getItem('itemNumber' + this.restaurantId)) {
      this.latestShortId = localStorage.getItem('itemNumber' + this.restaurantId)
    }
    this.defaultVatAmount = (this.$store.state.restaurantData && this.$store.state.restaurantData.vatDetails && this.$store.state.restaurantData.vatDetails.amount) ? this.$store.state.restaurantData.vatDetails.amount : '20'
  },
  methods: {
    chooseItems () {
        this.itemAccordingToCategory = []
        for (var i = 0; i < this.itemDataList.length; i++) {
            if (this.itemDataList[i].categoryId == this.categoryIdSelected) {
                let itemObj = {id: this.itemDataList[i].id, label: this.itemDataList[i].label}
                this.itemAccordingToCategory.push(itemObj)
                break
            }
        }
    },
    cancelCustomModal () {
        this.showCategoryItemModal = false

        // if user cancel the toppings.
        this.isToppingsModalEditable = false

        this.toppingsEditId = ''
        this.toppingsTitle = ''
        this.toppingsCategory = ''
        this.toppingsBasePrice = ''

        // if user cancel the category/item/selection
        this.title = ''
        this.description = ''
        this.basePrice = ''
        this.minOrderQty = 0
        this.categoryIdSelected = 0
        this.itemIdSelected = 0

        this.editCategoryId = 0
        this.editItemId = 0

        this.statusSelected = ''
        this.sendStatusSelected = ''
        this.printIdSelected = ''
        this.assignSelected = ''
        this.terminalSelected = ''
        this.printTypeSelected = ''
        this.servingTimes = []
    },
    editToppingsInfo () {
        let editableToppingsData = localStorage.getItem('editableToppingsData')

        editableToppingsData = JSON.parse(editableToppingsData)

        this.isToppingsModalEditable = true

        this.toppingsEditId = editableToppingsData.id
        this.toppingsTitle = editableToppingsData.title
        this.toppingsCategory = editableToppingsData.category
        this.toppingsBasePrice = editableToppingsData.price
    },
    categoryItemModal(general, fixed, custom, customTopping=false, create=false) {
      this.showCategoryItemModal = true
      window.scrollTo({ top: 0, behavior: "smooth"})
      this.addFixedMealDeal = fixed
      this.addCustomMealDeal = custom
      this.addGeneralMealDeal = general
      this.customTopping = customTopping
      if (create) {
        //select all days by default
        this.setOffDaysToAll()
        this.availableAt.delivery = true
        this.availableAt.collection = true
        this.customVatAmount = ''
        this.vat.status = ''
        this.vat.applicationType = ''
        this.vat.appliedFor = ''
        this.vatAppliedForIn = true
        this.vatAppliedForOut = true
        this.servingTimes = ['Morning', 'Lunch', 'Evening']
        this.statusSelected = 'Active'
        this.sendStatusSelected = 'Active'
      } else {
        //off days value reset
        this.resetOffDays()
        this.servingTimes = []
      }
    },
    editCategoryInfo (val, title, description, basePrice, priceDifference, inPrice, outPrice, categoryId, itemId, general, fixed, custom, terminal, print, assign, status, daysOff, specialItem, shortId, webToppingItems, menuShowAtOnline, vat, printType, menuShowAt, servingTimes, minOrderQty) {
      this.itemAccordingToCategory = []
      this.editCategoryId = val
      this.title = title
      this.description = description
      this.basePrice = basePrice == '' ? 0 : basePrice
      this.minOrderQty = (typeof minOrderQty === 'undefined' || minOrderQty === null || minOrderQty === '') ? 0 : minOrderQty
      this.categoryIdSelected = categoryId
      this.shortId = typeof shortId === 'undefined' ? null : shortId

      this.addFixedMealDeal = fixed
      this.addCustomMealDeal = custom
      this.addGeneralMealDeal = general

      this.isSetDiffPrice = priceDifference == 'Yes' ? true : false
      this.inPrice = inPrice
      this.outPrice = outPrice
      this.inPriceG = inPrice
      this.outPriceG = outPrice

      this.statusSelected = status
      this.sendStatusSelected = status
      this.printIdSelected = print
      this.assignSelected = assign
      this.terminalSelected = terminal
      this.specialItem = specialItem
      this.webToppingItems = webToppingItems
      this.printTypeSelected = printType

      this.menuShowAt = menuShowAt

      if(typeof menuShowAtOnline != 'undefined'){
        this.availableAt.delivery = menuShowAtOnline == "Delivery" ? true : false
        this.availableAt.collection = menuShowAtOnline == "Collection" ? true : false
      }else{
        this.availableAt.delivery = true
        this.availableAt.collection = true
      }

      if (vat) {
        this.vat.status = vat.status
        this.vat.applicationType = vat.applicationType
        this.vatAppliedForIn = vat.appliedFor == "Out" ? false : true
        this.vatAppliedForOut = vat.appliedFor == "In" ? false : true
        this.customVatAmount = vat.applicationType == 'Custom' ? vat.amount : ''
      }

      // previously selected available days
      this.availableDaysArray = (typeof daysOff !== 'undefined') ? daysOff : []
      // set previously selected available days to the view
      this.setAvailableDays()

      this.servingTimes = (typeof servingTimes !== 'undefined' && Array.isArray(servingTimes) && servingTimes.length) ? servingTimes : ['Morning', 'Lunch', 'Evening']

      if (itemId > 0) {
        for (var i = 0; i < this.itemDataList.length; i++) {
          if (this.itemDataList[i].categoryId == categoryId) {
            let itemObj = {id: this.itemDataList[i].id, label: this.itemDataList[i].label}

            this.itemAccordingToCategory.push(itemObj)
          }
        }

        setTimeout(() => {
          this.itemIdSelected = itemId
          this.editItemId = itemId
        }, 500)
      }
    },
    selctedCategory (val) {
      this.categoryIdSelected = val
    },
    createCategory () {
      let url = process.env.VUE_APP_API_URL+`/api/menu/create`
      let editUrl = process.env.VUE_APP_API_URL+`/api/menu/update`

      // request header
      let requestHeader = {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.jwtToken}`,
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Headers": "*",
          'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
      }

      // category
      if (this.isCategoryModal == true) {
        if (this.editCategoryId == 0) { //create
          this.vat.amount = this.vat.applicationType === 'Default' ? this.defaultVatAmount : this.customVatAmount
          this.vat.appliedFor = (this.vatAppliedForIn === this.vatAppliedForOut) ? "" : this.vatAppliedForIn ? "In" : "Out"
          let dataToSubmit = {
            // "id": 2,
            "restaurantId": this.restaurantId,
            "label": this.title,
            "resourceRef": "",
            "refCode": 0,
            "imgURL": "",
            "iconURL": "",
            "description": this.description,
            "categoryId": 0,
            "itemId": 0,
            "selectionId": 0,
            "toppingsId": 0,
            "modifierId": 0,
            "mealDealId": 0,
            "setId": 0,
            "printOptionId": this.printIdSelected,
            "printOptionTitle": "",
            "terminalOption": "",
            "status": this.sendStatusSelected,
            "basePrice": "",
            "toppingsCategory": "",
            "mealAssignFor": this.terminalSelected,
            "toppingsCategoryId": 0,
            "baseQty": 1,
            "minQty": 0,
            "maxQty": 0,
            "dataType": "Category",
            "mealDealType": "",
            "displayOrder": 2,
            "createdAt": "3 Sep 2020 11:05:30",
            "updatedAt": "30 Sep 2020 11:05:30",
            "children": [],
            "daysOff": this.availableDaysArray,
            "servingTimes": this.servingTimes,
            "vat": this.vat
          }

          axios
          .post(url, dataToSubmit,
          {
            headers: requestHeader
          })
          .then((data)=> {
            if (data.status == 200) {

              // this.showCategoryItemModal = true

              this.title = ''
              this.description = ''
              this.terminalSelected = ''
              this.sendStatusSelected = ''

              this.$toastr.s("Category created Successfully", "Success");
              this.$emit('categoryAndItem', data.data)

              setTimeout(() => {
                  this.resetValues()
              }, 500)
            }

            if (data.status === 403) {
              let logoutResponse = this.logout()
              if (logoutResponse === 1) {
                this.$router.push({ path: '/login' })
              }
            }
          })
        }
        else { //edit
          this.vat.amount = this.vat.applicationType === 'Default' ? this.defaultVatAmount : this.customVatAmount
          this.vat.appliedFor = (this.vatAppliedForIn === this.vatAppliedForOut) ? "" : this.vatAppliedForIn ? "In" : "Out"

          let dataToSubmit = {
            "id": this.editCategoryId,
            "restaurantId": this.restaurantId,
            "label": this.title,
            "resourceRef": "",
            "refCode": 0,
            "imgURL": "",
            "iconURL": "",
            "description": this.description,
            "categoryId": 0,
            "itemId": 0,
            "selectionId": 0,
            "toppingsId": 0,
            "modifierId": 0,
            "mealDealId": 0,
            "setId": 0,
            "printOptionId": this.printIdSelected,
            "printOptionTitle": "",
            "terminalOption": "",
            "status": this.sendStatusSelected,
            "basePrice": "",
            "toppingsCategory": "",
            "mealAssignFor": this.terminalSelected,
            "toppingsCategoryId": 0,
            "baseQty": 1,
            "minQty": 0,
            "maxQty": 0,
            "dataType": "Category",
            "mealDealType": "",
            "displayOrder": 2,
            "createdAt": "3 Sep 2020 11:05:30",
            "updatedAt": "30 Sep 2020 11:05:30",
            "children": [],
            "daysOff": this.availableDaysArray,
            "servingTimes": this.servingTimes,
            "vat": this.vat
          }

          if (this.menuShowAt) {
            dataToSubmit.menuShowAt = this.menuShowAt
          }

          axios
          .post(editUrl, dataToSubmit,
          {headers: requestHeader})
          .then((data)=> {
            // this.$emit("toppingsSubmitted")

            if (data.status == 200) {
              this.$toastr.s("Category edited Successfully", "Success");

              this.showCategoryItemModal = false

              this.title = ''
              this.description = ''

              this.$emit('categoryAndItem', data.data)

              setTimeout(() => {
                this.resetValues()
              }, 500)
            }

            if (data.status === 403) {
              let logoutResponse = this.logout()
              if (logoutResponse === 1) {
                this.$router.push({ path: '/login' })
              }
            }
          })
        }
      }

      // item
      if (this.isItemModal) {
        if (this.editCategoryId == 0) { //create
          this.vat.amount = this.vat.applicationType === 'Default' ? this.defaultVatAmount : this.customVatAmount
          this.vat.appliedFor = (this.vatAppliedForIn === this.vatAppliedForOut) ? "" : this.vatAppliedForIn ? "In" : "Out"

          let dataToSubmit = {
            "restaurantId": this.restaurantId,
            "label": this.title,
            "resourceRef": "",
            "refCode": 0,
            "imgURL": "",
            "iconURL": "",
            "description": this.description,
            "categoryId": localStorage.getItem('selectedCategoryId'),
            "itemId": 0,
            "selectionId": 0,
            "toppingsId": 0,
            "modifierId": 0,
            "mealDealId": 0,
            "setId": 0,
            "printOptionId": this.printIdSelected,
            "printOptionTitle": "",
            "terminalOption": "",
            "status": this.statusSelected,
            "basePrice": (typeof this.basePrice !== 'undefined' && this.basePrice !== '') ? this.basePrice : 0,
            "minOrderQty": (typeof this.minOrderQty !== 'undefined' && this.minOrderQty !== null && this.minOrderQty !== '') ? parseInt(this.minOrderQty) : 0,
            "toppingsCategory": "",
            "mealAssignFor": this.assignSelected,
            "toppingsCategoryId": 0,
            "baseQty": 1,
            "minQty": 0,
            "maxQty": 0,
            "dataType":  this.addGeneralMealDeal ? this.customTopping ? "CustomTopping" : "Item" : "MealDeal",
            "mealDealType": this.addGeneralMealDeal ? "" : this.addFixedMealDeal ? "Fixed" : "Custom",
            "displayOrder": 2,
            "createdAt": "3 Sep 2020 11:05:30",
            "updatedAt": "30 Sep 2020 11:05:30",
            "priceDifference": this.isSetDiffPrice === true ? "Yes" : "No",
            "inPrice": this.inPrice,
            "outPrice": this.outPrice,
            "children": [],
            "specialItem": this.specialItem === true ? 'Yes' : 'No',
            "shortId": (this.shortId === null || this.shortId === '') ? null : parseInt(this.shortId),
            "daysOff": this.availableDaysArray,
            "vat": this.vat
          }

          if(this.availableAt.delivery && !this.availableAt.collection){
            dataToSubmit.menuShowAtOnline = "Delivery"
          }else if(this.availableAt.collection && !this.availableAt.delivery){
            dataToSubmit.menuShowAtOnline = "Collection"
          }

          if (this.addCustomMealDeal && this.printTypeSelected) {
            dataToSubmit.printType = this.printTypeSelected
          }

          axios
          .post(url, dataToSubmit,
          {
            headers: requestHeader
          })
          .then((data)=> {
            // this.$emit("toppingsSubmitted")
            if (data.status == 200) {
              // set item number for specific restaurant
              this.setLastItemNumber()
              // this.showCategoryItemModal = false
              this.title = ''
              this.shortId = null
              this.description = ''
              // this.printIdSelected = 0
              // this.statusSelected = ''
              // this.assignSelected = ''
              this.categoryIdSelected = 0
              this.isSetDiffPrice = false
              this.inPrice = this.outPrice = ''
              this.specialItem = false

              this.$toastr.s("Item created Successfully", "Success");
              this.$emit('categoryAndItem', data.data)

              setTimeout(() => {
                this.resetValues()
              }, 500)
            }

            if (data.status === 403) {
              let logoutResponse = this.logout()
              if (logoutResponse === 1) {
                this.$router.push({ path: '/login' })
              }
            }
          })
          .catch ((error)=> {
            if (error.response.status === 400) {
              this.$toastr.Add({
              msg: 'Already assigned to ' + error.response.data.message, // Toast Message
              clickClose: false, // Click Close Disable
              timeout: 3000, // Remember defaultTimeout is 5 sec.(5000) in this case the toast won't close automatically
              type: "error", // Toast type,
              })
            }
          })
        }
        else { //edit
          this.vat.amount = this.vat.applicationType === 'Default' ? this.defaultVatAmount : this.customVatAmount
          this.vat.appliedFor = (this.vatAppliedForIn === this.vatAppliedForOut) ? "" : this.vatAppliedForIn ? "In" : "Out"

          let dataToSubmit = {
            "id": this.editCategoryId,
            "restaurantId": this.restaurantId,
            "label": this.title,
            "resourceRef": "",
            "refCode": 0,
            "imgURL": "",
            "iconURL": "",
            "description": this.description,
            "categoryId": localStorage.getItem('selectedCategoryId'),
            "itemId": 0,
            "selectionId": 0,
            "toppingsId": 0,
            "modifierId": 0,
            "mealDealId": 0,
            "setId": 0,
            "printOptionId": this.printIdSelected,
            "printOptionTitle": "",
            "terminalOption": "",
            "status": this.statusSelected,
            "basePrice": (typeof this.basePrice !== 'undefined' && this.basePrice !== '') ? parseFloat(this.basePrice) : 0,
            "minOrderQty": (typeof this.minOrderQty !== 'undefined' && this.minOrderQty !== null && this.minOrderQty !== '') ? parseInt(this.minOrderQty) : 0,
            "toppingsCategory": "",
            "mealAssignFor": this.assignSelected,
            "toppingsCategoryId": 0,
            "baseQty": 1,
            "minQty": 0,
            "maxQty": 0,
            "dataType":  this.addGeneralMealDeal ? this.customTopping ? "CustomTopping" : "Item" : "MealDeal",
            "mealDealType": this.addGeneralMealDeal ? "" : this.addFixedMealDeal ? "Fixed" : "Custom",
            "displayOrder": 2,
            "createdAt": "3 Sep 2020 11:05:30",
            "updatedAt": "30 Sep 2020 11:05:30",
            "priceDifference": this.isSetDiffPrice === true ? "Yes" : "No",
            "inPrice": this.inPrice,
            "outPrice": this.outPrice,
            "children": [],
            "specialItem": this.specialItem === true ? 'Yes' : 'No',
            "shortId": (this.shortId === null || this.shortId === '') ? null : parseInt(this.shortId),
            "daysOff": this.availableDaysArray,
            "webToppingItems": this.webToppingItems,
            "vat": this.vat
          }
          if(this.availableAt.delivery && !this.availableAt.collection){
            dataToSubmit.menuShowAtOnline = "Delivery"
          }else if(this.availableAt.collection && !this.availableAt.delivery){
            dataToSubmit.menuShowAtOnline = "Collection"
          }
          if (this.addCustomMealDeal && this.printTypeSelected) {
            dataToSubmit.printType = this.printTypeSelected
          }
          if (this.menuShowAt) {
            dataToSubmit.menuShowAt = this.menuShowAt
          }

          axios
          .post(editUrl, dataToSubmit, {headers: requestHeader})
          .then((data) => {
            // this.$emit("toppingsSubmitted")
            if (data.status == 200) {
              this.$toastr.s("Item edited Successfully", "Success");

              this.showCategoryItemModal = false

              this.setLastItemNumber()

              this.title = ''
              this.shortId = null
              this.description = ''
              this.categoryIdSelected = 0
              this.isSetDiffPrice = false
              this.inPrice = this.outPrice = ''
              this.specialItem = false

              this.$emit('categoryAndItem', data.data)

              setTimeout(() => {
                this.resetValues()
              }, 500)
            }

            if (data.status === 403) {
              let logoutResponse = this.logout()
              if (logoutResponse === 1) {
                this.$router.push({ path: '/login' })
              }
            }
          })
          .catch ((error)=> {
            if (error.response.status === 400) {
              this.$toastr.Add({
              msg: 'Already assigned to ' + error.response.data.message, // Toast Message
              clickClose: false, // Click Close Disable
              timeout: 3000, // Remember defaultTimeout is 5 sec.(5000) in this case the toast won't close automatically
              type: "error", // Toast type,
              })
            }
          })
        }
      }

      // selection
      if (this.isSelectionModal) {
        if (this.editCategoryId == 0 && this.editItemId == 0) { //create
          this.vat.amount = this.vat.applicationType === 'Default' ? this.defaultVatAmount : this.customVatAmount
          this.vat.appliedFor = (this.vatAppliedForIn === this.vatAppliedForOut) ? "" : this.vatAppliedForIn ? "In" : "Out"

          let dataToSubmit = {
            "restaurantId": this.restaurantId,
            "label": this.title,
            "resourceRef": "",
            "refCode": 0,
            "imgURL": "",
            "iconURL": "",
            "description": this.description,
            "categoryId": localStorage.getItem('selectedCategoryId'),
            "itemId": localStorage.getItem('selectedItemId'),
            "selectionId": 0,
            "toppingsId": 0,
            "modifierId": 0,
            "mealDealId": 0,
            "setId": 0,
            "printOptionId": this.printIdSelected,
            "printOptionTitle": "",
            "terminalOption": "",
            "status": this.statusSelected,
            "basePrice": (typeof this.basePrice !== 'undefined' && this.basePrice !== '') ? this.basePrice : 0,
            "toppingsCategory": "",
            "mealAssignFor": this.assignSelected,
            "toppingsCategoryId": 0,
            "baseQty": 1,
            "minQty": 0,
            "maxQty": 0,
            "dataType": "Selection",
            "mealDealType": "",
            "displayOrder": 2,
            "createdAt": "3 Sep 2020 11:05:30",
            "updatedAt": "30 Sep 2020 11:05:30",
            "priceDifference": this.isSetDiffPrice === true ? "Yes" : "No",
            "inPrice": this.inPrice,
            "outPrice": this.outPrice,
            "children": [],
            "specialItem": this.specialItem === true ? 'Yes' : 'No',
            "shortId": (this.shortId === null || this.shortId === '') ? null : parseInt(this.shortId),
            "daysOff": this.availableDaysArray,
            "vat": this.vat
          }

          if(this.availableAt.delivery && !this.availableAt.collection){
            dataToSubmit.menuShowAtOnline = "Delivery"
          }else if(this.availableAt.collection && !this.availableAt.delivery){
            dataToSubmit.menuShowAtOnline = "Collection"
          }

          axios
          .post(url, dataToSubmit,
          {
            headers: requestHeader
          })
          .then((data)=> {
            // this.$emit("toppingsSubmitted")

            if (data.status == 200) {
              this.$toastr.s("Selection created Successfully", "Success");

              // this.showCategoryItemModal = false
              this.setLastItemNumber()

              this.title = ''
              this.description = ''
              this.shortId = null
              // this.statusSelected = ''
              // this.assignSelected = ''
              this.categoryIdSelected = 0
              this.isSetDiffPrice = false
              this.inPrice = this.outPrice = ''
              this.specialItem = false

              this.$emit('categoryAndItem', data.data)

              setTimeout(() => {
                this.resetValues()
              }, 500)
            }

            if (data.status === 403) {
              let logoutResponse = this.logout()
              if (logoutResponse === 1) {
                this.$router.push({ path: '/login' })
              }
            }
          })
          .catch ((error)=> {
            if (error.response.status === 400) {
              this.$toastr.Add({
              msg: 'Already assigned to ' + error.response.data.message, // Toast Message
              clickClose: false, // Click Close Disable
              timeout: 3000, // Remember defaultTimeout is 5 sec.(5000) in this case the toast won't close automatically
              type: "error", // Toast type,
              })
            }
          })
        }
        else { //edit
          this.vat.amount = this.vat.applicationType === 'Default' ? this.defaultVatAmount : this.customVatAmount
          this.vat.appliedFor = (this.vatAppliedForIn === this.vatAppliedForOut) ? "" : this.vatAppliedForIn ? "In" : "Out"

          let dataToSubmit = {
            "id": this.editCategoryId,
            "restaurantId": this.restaurantId,
            "label": this.title,
            "resourceRef": "",
            "refCode": 0,
            "imgURL": "",
            "iconURL": "",
            "description": this.description,
            "categoryId": this.categoryIdSelected,
            "itemId": this.itemIdSelected,
            "selectionId": 0,
            "toppingsId": 0,
            "modifierId": 0,
            "mealDealId": 0,
            "setId": 0,
            "printOptionId": this.printIdSelected,
            "printOptionTitle": "",
            "terminalOption": "",
            "status": this.statusSelected,
            "basePrice": (typeof this.basePrice !== 'undefined' && this.basePrice !== '') ? this.basePrice : 0,
            "toppingsCategory": "",
            "mealAssignFor": this.assignSelected,
            "toppingsCategoryId": 0,
            "baseQty": 1,
            "minQty": 0,
            "maxQty": 0,
            "dataType": "Selection",
            "mealDealType": "",
            "displayOrder": 2,
            "createdAt": "3 Sep 2020 11:05:30",
            "updatedAt": "30 Sep 2020 11:05:30",
            "priceDifference": this.isSetDiffPrice === true ? "Yes" : "No",
            "inPrice": this.inPrice,
            "outPrice": this.outPrice,
            "children": [],
            "specialItem": this.specialItem === true ? 'Yes' : 'No',
            "shortId": (this.shortId === null || this.shortId === '') ? null : parseInt(this.shortId),
            "daysOff": this.availableDaysArray,
            "vat": this.vat
          }

          if(this.availableAt.delivery && !this.availableAt.collection){
            dataToSubmit.menuShowAtOnline = "Delivery"
          }else if(this.availableAt.collection && !this.availableAt.delivery){
            dataToSubmit.menuShowAtOnline = "Collection"
          }

          if (this.menuShowAt) {
            dataToSubmit.menuShowAt = this.menuShowAt
          }

          axios
          .post(editUrl, dataToSubmit,
          {
              headers: requestHeader
          })
          .then((data)=> {
            // this.$emit("toppingsSubmitted")

            if (data.status == 200) {
              this.$toastr.s("Selection edited Successfully", "Success");

              this.showCategoryItemModal = false

              this.setLastItemNumber()

              this.title = ''
              this.description = ''
              this.shortId = null
              this.categoryIdSelected = 0
              this.isSetDiffPrice = false
              this.inPrice = this.outPrice = ''
              this.specialItem = false

              this.$emit('categoryAndItem', data.data)

              setTimeout(() => {
                this.resetValues()
              }, 500)
            }

            if (data.status === 403) {
              let logoutResponse = this.logout()
              if (logoutResponse === 1) {
                this.$router.push({ path: '/login' })
              }
            }
          })
          .catch ((error)=> {
            if (error.response.status === 400) {
              this.$toastr.Add({
              msg: 'Already assigned to ' + error.response.data.message, // Toast Message
              clickClose: false, // Click Close Disable
              timeout: 3000, // Remember defaultTimeout is 5 sec.(5000) in this case the toast won't close automatically
              type: "error", // Toast type,
              })
            }
          })
        }
      }
    },
    resetValues () {
        this.itemAccordingToCategory = []

        this.editCategoryId = 0
        this.editItemId = 0
        this.title = ''
        this.description = ''
        this.basePrice = 0
        this.minOrderQty = 0
        this.categoryIdSelected = 0
        this.itemIdSelected = 0
    },
    createToppings () {

        let url = process.env.VUE_APP_API_URL+`/api/topping/create`
        let editUrl = process.env.VUE_APP_API_URL+`/api/topping/update`

        // request header
        let requestHeader = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.jwtToken}`,
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Credentials": true,
            "Access-Control-Allow-Headers": "*",
            'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        }

        if (this.isToppingsModalEditable) {
            let dataToSubmit = {
                "id": this.toppingsEditId,
                "restaurantId": this.restaurantId,
                "label": this.toppingsTitle,
                "resourceRef": "toppings-1",
                "refCode": 3000,
                "imgURL": "",
                "iconURL": "",
                "description": "",
                "categoryId": 0,
                "itemId": 0,
                "selectionId": 0,
                "toppingsId": 3000,
                "modifierId": 0,
                "mealDealId": 0,
                "setId": 0,
                "printOptionId": 1,
                "printOptionTitle": "",
                "terminalOption": "",
                "status": "Active",
                "basePrice": (typeof this.toppingsBasePrice !== 'undefined' && this.toppingsBasePrice !== '') ? this.toppingsBasePrice : 0,
                "toppingsCategory": this.toppingsCategory,
                "mealAssignFor": "",
                // "toppingsCategoryId": 1,
                "baseQty": 1,
                "minQty": 0,
                "maxQty": 0,
                "dataType": "Toppings",
                "mealDealType": "",
                "displayOrder": 1,
                "createdAt": "3 Sep 2020 11:05:30",
                "updatedAt": "30 Sep 2020 11:05:30",
                "children": []
            }

            axios
            .post(editUrl, dataToSubmit,
            {
                headers: requestHeader
            })
            .then((data)=> {
                this.$emit("toppingsSubmitted")

                if (data.status == 200) {
                    this.$toastr.s("Created Successfully", "Success");

                    this.showCategoryItemModal = false

                    this.isToppingsModalEditable = false

                    this.toppingsEditId = ''
                    this.toppingsTitle = ''
                    this.toppingsCategory = ''
                    this.toppingsBasePrice = ''

                    localStorage.removeItem('editableToppingsData')
                }

                if (data.status === 403) {
                    let logoutResponse = this.logout()
                    if (logoutResponse === 1) {
                        this.$router.push({ path: '/login' })
                    }
                }
            })
        }
        else {
            let dataToSubmit = {
                // "id": this.toppingsEditId,
                "restaurantId": this.restaurantId,
                "label": this.toppingsTitle,
                "resourceRef": "toppings-1",
                "refCode": 3000,
                "imgURL": "",
                "iconURL": "",
                "description": "",
                "categoryId": 0,
                "itemId": 0,
                "selectionId": 0,
                "toppingsId": 3000,
                "modifierId": 0,
                "mealDealId": 0,
                "setId": 0,
                "printOptionId": 1,
                "printOptionTitle": "",
                "terminalOption": "",
                "status": "Active",
                "basePrice": (typeof this.toppingsBasePrice !== 'undefined' && this.toppingsBasePrice !== '') ? this.toppingsBasePrice : 0,
                "toppingsCategory": this.toppingsCategory,
                "mealAssignFor": "",
                "toppingsCategoryId": 1,
                "baseQty": 1,
                "minQty": 0,
                "maxQty": 0,
                "dataType": "Toppings",
                "mealDealType": "",
                "displayOrder": 1,
                "createdAt": "3 Sep 2020 11:05:30",
                "updatedAt": "30 Sep 2020 11:05:30",
                "children": []
            }

            axios
            .post(url, dataToSubmit,
            {
                headers: requestHeader
            })
            .then((data)=> {
                this.$emit("toppingsSubmitted")

                if (data.status == 200) {
                    this.$toastr.s("Created Successfully", "Success");

                    this.showCategoryItemModal = false

                    this.toppingsEditId = ''
                    this.toppingsTitle = ''
                    this.toppingsCategory = ''
                    this.toppingsBasePrice = ''
                }

                if (data.status === 403) {
                    let logoutResponse = this.logout()
                    if (logoutResponse === 1) {
                        this.$router.push({ path: '/login' })
                    }
                }
            })
        }
    },
    setDiffPrice() {
      this.isSetDiffPrice = !this.isSetDiffPrice
      if (this.isSetDiffPrice === false) {
          this.inPrice = this.outPrice = '';
      }else{
          this.inPrice = this.inPriceG
          this.outPrice = this.outPriceG;
      }
    },
    setLastItemNumber () {
      if (this.shortId) {
        localStorage.setItem('itemNumber'+this.restaurantId, this.shortId)
        this.latestShortId = this.shortId
      }
    },
    toggleDayList () {
      this.isAvailableDayClicked = !this.isAvailableDayClicked
    },
    selectAvailableDay (day) {
      if (this.availableDays.all && day != 'All') {
        this.availableDays.all= false
        this.availableDaysArray = []
        if (this.availableDays.sun) { this.availableDaysArray.push('Sun') }
        if (this.availableDays.mon) { this.availableDaysArray.push('Mon') }
        if (this.availableDays.tue) { this.availableDaysArray.push('Tue') }
        if (this.availableDays.wed) { this.availableDaysArray.push('Wed') }
        if (this.availableDays.thu) { this.availableDaysArray.push('Thu') }
        if (this.availableDays.fri) { this.availableDaysArray.push('Fri') }
        if (this.availableDays.sat) { this.availableDaysArray.push('Sat') }
        this.availableDaysArray = this.availableDaysArray.filter(d => d !== day)
      } else {
        if (this.availableDaysArray.includes(day)) {
          this.availableDaysArray = this.availableDaysArray.filter(d => d !== day)
          if (day == 'All') {
            this.availableDays.all= false
            this.availableDays.sun= false
            this.availableDays.mon= false
            this.availableDays.tue= false
            this.availableDays.wed= false
            this.availableDays.thu= false
            this.availableDays.fri= false
            this.availableDays.sat= false
            this.availableDaysArray = []
          }
        } else {
          if (day == 'All') {
            this.availableDays.all= true
            this.availableDays.sun= true
            this.availableDays.mon= true
            this.availableDays.tue= true
            this.availableDays.wed= true
            this.availableDays.thu= true
            this.availableDays.fri= true
            this.availableDays.sat= true

            this.availableDaysArray = ['All']
          } else {
            this.availableDaysArray.push(day)
          }
        }
      }
    },
    setAvailableDays () {
      //off days value reset
      this.isAvailableDayClicked = false
      this.availableDays.all = null
      this.availableDays.sun = null
      this.availableDays.mon = null
      this.availableDays.tue = null
      this.availableDays.wed = null
      this.availableDays.thu = null
      this.availableDays.fri = null
      this.availableDays.sat = null

      this.availableDaysArray.forEach(day => {
        if (day == 'All') {
          this.availableDays.all= true
          this.availableDays.sun= true
          this.availableDays.mon= true
          this.availableDays.tue= true
          this.availableDays.wed= true
          this.availableDays.thu= true
          this.availableDays.fri= true
          this.availableDays.sat= true
        } else {
          if (day == 'Sun') { this.availableDays.sun = true }
          if (day == 'Mon') { this.availableDays.mon = true }
          if (day == 'Tue') { this.availableDays.tue = true }
          if (day == 'Wed') { this.availableDays.wed = true }
          if (day == 'Thu') { this.availableDays.thu = true }
          if (day == 'Fri') { this.availableDays.fri = true }
          if (day == 'Sat') { this.availableDays.sat = true }
        }
      })
    },
    resetOffDays () {
      this.isAvailableDayClicked = false
      this.availableDays.all = null
      this.availableDays.sun = null
      this.availableDays.mon = null
      this.availableDays.tue = null
      this.availableDays.wed = null
      this.availableDays.thu = null
      this.availableDays.fri = null
      this.availableDays.sat = null
      this.availableDaysArray = []
    },
    setOffDaysToAll () {
      this.isAvailableDayClicked = false
      this.availableDays.all = true
      this.availableDays.sun = true
      this.availableDays.mon = true
      this.availableDays.tue = true
      this.availableDays.wed = true
      this.availableDays.thu = true
      this.availableDays.fri = true
      this.availableDays.sat = true
      this.availableDaysArray = ["All"]
    }
  },
  watch: {
    selectedItemPrintOptionId (selectedItemPrintOptionId) {
      this.printIdSelected = selectedItemPrintOptionId
    }
  }
}
</script>

<style >
.modal-vue .overlay {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
}

.modal-vue .modal-own {
    position: absolute;
    width: 500px;
    z-index: 9999;
    margin: 0 auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 10px;
    top: 5%;
    left: 30%;
}

.modal-vue .close{
    position: absolute;
    top: 10px;
    right: 10px;
}

h5 {
    color: #FE7611 !important;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
}

.submitBtn {
    background-color: #E317E3;
    color: white;
    border-color:  #E317E3;
}

.cancelBtn {
    background-color: #797979;
    color: white;
    border-color:  #797979;
}
.availableDays{width: 100%;}
.availableDays .dropdown-menu{
  opacity: 1;
  bottom: 100%;
  top: unset !important;
  line-height: 2rem;
  padding: 1rem 1.5rem;
  min-width: 115px !important;
  text-align: right;
}
.availableDays input{margin-left: .5rem; width: 15px; height: 15px;}
.customer-radio{width: 20px; height: 20px; border: 1px solid #797979; border-radius: 50%;}
.customer-radio.active{background-color: #797979;}
</style>
